import {
  ActionIcon,
  Group,
  Loader,
  Stack,
  Text,
  TextInput,
  ThemeIcon,
} from "@mantine/core";
import { IconCheck, IconSearch, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { checkDomainAvailability } from "../../../../api/ovh";
import { getCurrencySymbol } from "../../../../functions/utilFunctions";
import { useLanguage } from "../../../../stores/LanguageStore";

const OvhDomainSearch = ({
  apiKey,
  domain,
  setDomain,
  domainSearch,
  setDomainSearch,
  details,
  setDetails,
}) => {
  const lang = useLanguage((s) => s.language);
  const [searching, setSearching] = useState(false);
  const [available, setAvailable] = useState(null);

  const handleSearch = (v) => {
    setSearching(true);
    checkDomainAvailability({ domain: v, external_api_key_id: apiKey })
      .then((res) => {
        if (res.data.available === true) {
          setAvailable(true);
          setDomain(v);
          setDetails({
            currencyCode: res.data.currencyCode,
            domainPrice: res.data.price,
          });
        } else {
          setAvailable(false);
          setDomain(null);
        }
      })
      .catch((err) => {
        setAvailable(false);
        setDomain(null);
      })
      .finally(() => setSearching(false));
  };

  return (
    <Stack>
      <TextInput
        label={lang.ovh.step2.search}
        value={domainSearch}
        onChange={(e) => {
          setDomainSearch(e.target.value);
          setDomain(null);
          setAvailable(null);
        }}
        placeholder="exemple: mydomain.ltd"
        id="domain-search-input"
        rightSection={
          <ActionIcon
            onClick={() => handleSearch(domainSearch)}
            loading={searching}
            size={"xl"}
            variant="light"
            disabled={!domainSearch}
          >
            {available ? <IconCheck /> : <IconSearch />}
          </ActionIcon>
        }
        size="lg"
        onKeyDown={(e) => {
          if (e.key === "Enter" && e.target.value) {
            handleSearch(e.target.value);
          }
        }}
      />

      {searching ? (
        <Group wrap="nowrap">
          <Loader type="oval" size={32} />
          <Text size="lg">{lang.ovh.step2.verification}</Text>
        </Group>
      ) : available ? (
        <Group wrap="nowrap">
          <ThemeIcon size={40} color="green.8" variant="light" radius={"xl"}>
            <IconCheck size={20} />
          </ThemeIcon>
          <Text size="lg" c={"green.8"}>
            {lang.ovh.step2.available}{" "}
          </Text>

          <Text fz={24} c={"green.8"} fw={700}>
            {details.domainPrice} {getCurrencySymbol(details.currencyCode)}{" "}
            {lang.ovh.step4.per_year}
          </Text>
        </Group>
      ) : available === false ? (
        <Group wrap="nowrap">
          <ThemeIcon size={40} color="red.8" variant="light" radius={"xl"}>
            <IconX size={20} />
          </ThemeIcon>
          <Text size="lg" c={"red.8"}>
            {lang.ovh.step2.unavailable}
          </Text>
        </Group>
      ) : (
        ""
      )}

      {!domain && (
        <Text>
          {!searching && (
            <>
              {lang.ovh.step2.text1} <b>{lang.ovh.step2.enter}</b>{" "}
              {lang.ovh.step2.text2}
              <br /> <br />
            </>
          )}{" "}
          {lang.ovh.step2.text3}
        </Text>
      )}
    </Stack>
  );
};

export default OvhDomainSearch;
